import { z } from "zod";
import { zodDayjs } from "../utils/zodHelpers";

export const MeasurementSaveRequestSchema = z.object({
  date: zodDayjs,
  fieldAlias: z.string(),
  value: z.string(),
});

export type MeasurementSaveRequest = z.infer<
  typeof MeasurementSaveRequestSchema
>;

export const MeasurementSchema = z.object({
  measurementId: z.number(),
  date: zodDayjs,
  fieldAlias: z.string(),
  value: z.string(),
});

export type Measurement = z.infer<typeof MeasurementSchema>;

export const MeasurementsSchema = z.object({
  measurements: z.array(MeasurementSchema),
});

export type Measurements = z.infer<typeof MeasurementsSchema>;
